export type ButtonColor = 'blue' | 'red' | 'gray' | 'slate' | 'white' | 'amber'
export type ButtonAppearance = 'primary' | 'ring' | 'secondary' | 'text'

export const ButtonAppearances = {
  primary: {
    red: 'text-white disabled:bg-red-400 enabled:bg-red-600 enabled:hover:bg-red-500',
    amber:
      'text-white disabled:bg-amber-400 enabled:bg-amber-600 enabled:hover:bg-amber-500',
    blue: 'text-white disabled:bg-blue-400 enabled:bg-blue-600 enabled:hover:bg-blue-500',
    gray: 'text-white disabled:bg-gray-400 enabled:bg-gray-600 enabled:hover:bg-gray-500',
    slate:
      'text-white disabled:bg-slate-400 enabled:bg-slate-600 enabled:hover:bg-slate-500',
    white:
      'text-slate-800 disabled:text-slate-300 enabled:bg-gray-50 enabled:hover:bg-gray-100',
  },
  secondary: {
    red: 'disabled:bg-red-50 disabled:text-red-300 enabled:bg-red-50 enabled:hover:bg-red-100 enabled:text-red-600',
    amber:
      'disabled:bg-amber-50 disabled:text-amber-300 enabled:bg-amber-50 enabled:hover:bg-amber-100 enabled:text-amber-600',
    blue: 'disabled:bg-blue-50 disabled:text-blue-300 enabled:bg-blue-50 enabled:hover:bg-blue-100 enabled:text-blue-600',
    gray: 'disabled:bg-gray-100 disabled:text-gray-400 enabled:bg-gray-300 enabled:hover:bg-gray-400 enabled:text-gray-700',
    slate:
      'disabled:bg-slate-100 disabled:text-slate-400 enabled:bg-slate-300 enabled:hover:bg-slate-400 enabled:text-slate-700',
    white: '',
  },
  ring: {
    red: 'ring-1 bg-white disabled:text-red-400 disabled:ring-red-300 enabled:ring-red-300 enabled:text-red-600 enabled:hover:bg-red-100 shadow-sm',
    amber:
      'ring-1 bg-white disabled:text-amber-400 disabled:ring-amber-300 enabled:ring-amber-300 enabled:text-amber-600 enabled:hover:bg-amber-100 shadow-sm',
    blue: 'ring-1 bg-white disabled:text-blue-400 disabled:ring-blue-300 enabled:ring-blue-500 enabled:text-blue-600 enabled:hover:bg-blue-100 shadow-sm',
    gray: 'ring-1 bg-white disabled:text-gray-400 disabled:ring-gray-300 enabled:ring-gray-300 enabled:text-gray-600 enabled:hover:bg-gray-100 shadow-sm',
    slate:
      'ring-1 bg-white disabled:text-slate-400 disabled:ring-slate-300 enabled:ring-slate-300 enabled:text-slate-600 enabled:hover:bg-slate-100 shadow-sm',
    white: '',
  },
  text: {
    red: 'bg-white disabled:text-red-400 disabled:ring-red-300 enabled:ring-red-600 enabled:text-red-600',
    amber:
      'bg-white disabled:text-amber-400 disabled:ring-amber-300 enabled:ring-amber-600 enabled:text-amber-600',
    blue: 'bg-white disabled:text-blue-400 disabled:ring-blue-300 enabled:ring-blue-600 enabled:text-blue-600',
    gray: 'bg-white disabled:text-gray-400 disabled:ring-gray-300 enabled:ring-gray-600 enabled:text-gray-600',
    slate:
      'bg-white disabled:text-slate-400 disabled:ring-slate-300 enabled:ring-slate-600 enabled:text-slate-600',
    white: '',
  },
}
